(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wa-brand-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = () => document.querySelectorAll('[data-wa-story-video]').forEach(video => {
    if (initialized.has(video)) return;
    initialized.add(video);
    const toggle = video.parentElement.querySelector('[data-wa-video-toggle]');
    let manuallyPaused = false;
    const updateControl = () => {
      toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      toggle.querySelector('[data-video-play]').hidden = !video.paused;
      toggle.querySelector('[data-video-pause]').hidden = video.paused;
    };
    toggle.addEventListener('click', () => {
      if (video.paused) {
        manuallyPaused = false;
        video.play().catch(() => {});
      } else {
        manuallyPaused = true;
        video.pause();
      }
    });
    video.addEventListener('play', updateControl);
    video.addEventListener('pause', updateControl);
    updateControl();
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        const source = video.querySelector('source[data-src]');
        if (source) {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
          video.load();
        }
        if (!reducedMotion.matches && !manuallyPaused) video.play().catch(() => {});
      } else {
        video.pause();
      }
    }), { threshold: 0.15 });
    observer.observe(video);
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) video.pause();
    });
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wa-game-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  const init = () => document.querySelectorAll('[data-home-shop]').forEach(root => {
    if (initialized.has(root)) return;
    initialized.add(root);
    const strings = JSON.parse(root.querySelector('[data-home-shop-strings]').textContent);
    const panels = root.querySelectorAll('[data-home-product]');
    const selector = root.querySelector('[data-home-selector]');
    const choices = [...selector.querySelectorAll('[data-home-select]')];
    const selectMachine = id => {
      panels.forEach(panel => panel.hidden = panel.dataset.machineId !== id);
      choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.homeSelect === id)));
    };
    if (choices.length) {
      selector.hidden = false;
      selectMachine(choices[0].dataset.homeSelect);
      choices.forEach(choice => choice.addEventListener('click', () => selectMachine(choice.dataset.homeSelect)));
      document.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-home-product]');
        if (panel && root.contains(panel)) selectMachine(panel.dataset.machineId);
      });
    }
    panels.forEach(panel => {
      const form = panel.querySelector('.wa-purchase__form');
      const button = form.querySelector('[name="add"]');
      const buttonLabel = button.querySelector('[data-home-button-label]');
      const status = panel.querySelector('[data-home-status]');
      const cartActions = panel.querySelector('[data-home-cart-actions]');
      const image = panel.querySelector('.wa-purchase__image');
      const details = panel.querySelector('[data-home-details]');
      const thumbnails = panel.querySelectorAll('[data-home-photo]');
      thumbnails.forEach(thumbnail => thumbnail.addEventListener('click', () => {
        if (!image) return;
        image.style.objectFit = thumbnail.dataset.imageFit;
        image.srcset = thumbnail.dataset.imageSrcset;
        image.src = thumbnail.dataset.imageSrc;
        thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item === thumbnail)));
      }));
      let busy = false;
      form.addEventListener('change', event => {
        if (event.target.name !== 'id') return;
        const option = event.target;
        panel.querySelector('[data-home-price]').textContent = option.dataset.price;
        button.disabled = busy || option.dataset.available !== 'true';
        buttonLabel.textContent = option.dataset.available === 'true' ? strings.add : strings.sold_out;
        status.textContent = '';
        if (image && option.dataset.imageSrc) {
          image.style.objectFit = option.dataset.imageFit;
          image.srcset = option.dataset.imageSrcset;
          image.src = option.dataset.imageSrc;
          thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item.dataset.imageSrc === option.dataset.imageSrc)));
        }
        const url = new URL(details.href);
        url.searchParams.set('variant', option.value);
        details.href = url.href;
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        busy = true;
        const payload = new FormData(form);
        const fieldset = form.querySelector('fieldset');
        if (fieldset) fieldset.disabled = true;
        form.querySelector('[name="quantity"]').readOnly = true;
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        buttonLabel.textContent = strings.adding;
        status.textContent = '';
        panel.classList.remove('wa-purchase--error');
        try {
          const response = await fetch(root.dataset.cartAddUrl + '.js', { method: 'POST', body: payload, headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || strings.error);
          status.textContent = strings.added;
          cartActions.hidden = false;
          document.dispatchEvent(new CustomEvent('wa:cart-added', { detail: { product: result } }));
          try {
            const cartResponse = await fetch(root.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.querySelectorAll('.wa-header__cart-count').forEach(count => count.textContent = cart.item_count);
              document.querySelectorAll('[data-wa-cart-link]').forEach(link => link.setAttribute('aria-label', strings.cart_label.replace('__COUNT__', cart.item_count)));
            }
          } catch {}
        } catch (error) {
          status.textContent = error instanceof TypeError ? strings.error : error.message || strings.error;
          cartActions.hidden = false;
          panel.classList.add('wa-purchase--error');
        } finally {
          busy = false;
          if (fieldset) fieldset.disabled = false;
          form.querySelector('[name="quantity"]').readOnly = false;
          form.removeAttribute('aria-busy');
          const selected = form.querySelector('[name="id"]:checked');
          button.disabled = selected ? selected.dataset.available !== 'true' : false;
          buttonLabel.textContent = button.disabled ? strings.sold_out : strings.add;
        }
      });
    });
  });
  const reveal = () => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('wa-is-visible');
      observer.unobserve(entry.target);
    }), { threshold: 0.08 });
    document.querySelectorAll('.wa-home-story__content, .wa-gameplay__copy, .wa-reviews__header, .wa-finder__invite > div:first-child').forEach(element => {
      if (element.classList.contains('wa-reveal')) return;
      element.classList.add('wa-reveal');
      observer.observe(element);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal); else reveal();
  document.addEventListener('shopify:section:load', reveal);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wa-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  const init = () => document.querySelectorAll('[data-wa-header]').forEach(header => {
    if (initialized.has(header)) return;
    initialized.add(header);
    const wrapper = header.closest('.wa-header-section');
    if (!wrapper) return;
    const controller = new AbortController();
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let previousY = Math.max(0, scrollY);
    let direction = 0;
    let distance = 0;
    let frame = 0;
    const reveal = () => wrapper.classList.remove('wa-header-is-hidden');
    const update = () => {
      frame = 0;
      const y = Math.max(0, scrollY);
      const delta = y - previousY;
      previousY = y;
      wrapper.classList.toggle('wa-header-is-scrolled', y > 24);
      if (y < 120 || header.querySelector('details[open]') || header.contains(document.activeElement) && document.activeElement.matches(':focus-visible') || document.querySelector('dialog[open]')) {
        reveal();
        distance = 0;
        return;
      }
      if (Math.abs(delta) < 2) return;
      const nextDirection = delta > 0 ? 1 : -1;
      distance = nextDirection === direction ? distance + Math.abs(delta) : Math.abs(delta);
      direction = nextDirection;
      if (distance > (direction === 1 ? 24 : 12)) wrapper.classList.toggle('wa-header-is-hidden', direction === 1);
    };
    addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true, signal: controller.signal });
    header.addEventListener('focusin', reveal, { signal: controller.signal });
    header.querySelectorAll('details').forEach(details => details.addEventListener('toggle', () => { if (details.open) reveal(); }, { signal: controller.signal }));
    reduced.addEventListener('change', reveal, { signal: controller.signal });
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(header)) return;
      controller.abort();
      if (frame) cancelAnimationFrame(frame);
    }, { signal: controller.signal });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
